export const COURSERA_PLUS_COLORS = {
  LOGO_DARK: '#fff',
  LOGO_INVERT_DARK: '#000',
  PLUS_LIGHT: '#fff',
  PLUS_DARK: '#000',
  PLUS_INVERT_DARK: '#fff',
  PLUS_BLACK: '#000',
} as const;
